export default "__VITE_ASSET__SnO8t_gh__"